<app-slider-horizontal [items]="sectionInfo.array" [itemTemplate]="zonesTemplate"></app-slider-horizontal>

<ng-template #zonesTemplate let-zone>
    <div class="zone-img">
        <img [src]="zone.imageUrl" alt="City zone" class="zone-img">
        <div class="margin-1rem">
            <h5 class="webapp-pre-title center">{{zone.name}}</h5>
        </div>
    </div>
</ng-template>